import { currencyFormat } from '../../../Functions';

export function VLogoCompose(page, rowL, cts, dataUrl, times) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;

    if (times === 'first'){
        _y = page.headerFromTop;
    }

    var imageX = 140;
    doc.addImage(dataUrl, 'JPEG', imageX, _y, 50, 18);

    _y += _space * 4;

    return _y;
}

export function VCTSHeadingCompose(page, rowL, cts, data) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;
    // console.log('data', data)
    let current_datetime = new Date()
    let DateReturn = new Date(data[0].dateReturned)
    let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()
    let formatted_dateReturn = (DateReturn.getMonth() + 1) + "/" + DateReturn.getDate() + "/" + DateReturn.getFullYear() + " " + DateReturn.getHours() + ":" + DateReturn.getMinutes() + ":" + DateReturn.getSeconds()

    if(data && data.length > 1){
        doc.setFont("times", "bold");
        doc.text('CARGO TRANSFER SLIP', 110, _y, null, null, 'center');
        _y += _space;
        doc.text('TANDEM', 110, _y, null, null, 'center');
        doc.setFont("times", "normal");
    
        _y += _space * 2;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Date:');
        doc.setFont("times", "normal");
        doc.text(35, _y, formatted_date);
    
        doc.setFont("times", "bold");
        doc.text(120, _y, 'Date Returned:');
        doc.setFont("times", "normal");
        doc.text(155, _y, formatted_dateReturn);
    
        _y += _space;
    
        // doc.setFont("times", "bold");
        // // doc.text(20, _y, 'CTS No:');
        // doc.text(20, _y, 'VAN-IN No:');
        // doc.setFont("times", "normal");
        // doc.text(45, _y, data[0].vanInId ? data[0].vanInId : '');

        // doc.setFont("times", "bold");
        // doc.text(20, _y, 'Booking Reference:');
        // doc.setFont("times", "normal");
        // doc.text(65, _y, data[0].bookingRef ? data[0].bookingRef : '');
    
        doc.setFont("times", "bold");
        doc.text(136, _y, 'Branch:');
        doc.setFont("times", "normal");
        doc.text(155, _y, data[0].branchName ? data[0].branchName : '');
    
        // _y += _space;
    
        // doc.setFont("times", "bold");
        // doc.text(124, _y, 'CTS VAN-OUT:');
        // doc.setFont("times", "normal");
        // doc.text(155, _y, data[0].ctsNum ? data[0].ctsNum : '');
    
        _y += _space * 2;
    }
    else {
        doc.setFont("times", "bold");
        doc.text('CARGO TRANSFER SLIP', 110, _y, null, null, 'center');
        doc.setFont("times", "normal");
    
        _y += _space * 2;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Date:');
        doc.setFont("times", "normal");
        doc.text(35, _y, formatted_date);
    
        doc.setFont("times", "bold");
        doc.text(120, _y, 'Date Returned:');
        doc.setFont("times", "normal");
        doc.text(155, _y, formatted_dateReturn);
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Booking Reference:');
        doc.setFont("times", "normal");
        doc.text(65, _y, data[0].bookingRef ? data[0].bookingRef : '');
    
        doc.setFont("times", "bold");
        doc.text(136, _y, 'Branch:');
        doc.setFont("times", "normal");
        doc.text(155, _y, data[0].branchName ? data[0].branchName : '');
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'VAN-IN No:');
        doc.setFont("times", "normal");
        doc.text(45, _y, data[0].vanInId ? data[0].vanInId : '');
    
        doc.setFont("times", "bold");
        doc.text(124, _y, 'CTS VAN-OUT:');
        doc.setFont("times", "normal");
        doc.text(155, _y, data[0].ctsNum ? data[0].ctsNum : '');
    
        _y += _space * 2;
    }

    return _y;
}

export function VCTSContentCompose(page, rowL, cts, data, containerPic) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;
    // console.log('data', data);
    if(data && data.length > 1) {
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Trucker:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].truckerName ? data[0].truckerName : '');
        doc.line(55, _y + 1, 195, _y + 1);
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Plate Number:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].plateNum ? data[0].plateNum : '');
        doc.line(55, _y + 1, 195, _y + 1);
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Driver:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].driver ? data[0].driver : '');
        doc.line(55, _y + 1, 195, _y + 1);
    
        _y += _space * 2;
      
        doc.setFont("times", "bold");
        doc.text(20, _y, 'VAN-IN No:');
        doc.setFont("times", "normal");
        doc.text(45, _y, data[0].vanInId ? data[0].vanInId : '');

        doc.setFont("times", "bold");
        doc.text(115, _y, 'VAN-IN No:');
        doc.setFont("times", "normal");
        doc.text(140, _y, data[1].vanInId ? data[1].vanInId : '');
       
        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Van No');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].containerVan ? data[0].containerVan : '');
        doc.line(40, _y + 1, 100, _y + 1);
    
        doc.setFont("times", "bold");
        doc.text(115, _y, 'Van No');
        doc.setFont("times", "normal");
        doc.text(135, _y, data[1].containerVan ? data[1].containerVan : '');
        doc.line(135, _y + 1, 195, _y + 1);
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Seal No');
        doc.setFont("times", "normal");
        // doc.text(40, _y, data[0].sealNum ? data[0].sealNum : '');
        doc.line(40, _y + 1, 100, _y + 1);
    
        doc.setFont("times", "bold");
        doc.text(115, _y, 'Seal No');
        doc.setFont("times", "normal");
        // doc.text(110, _y, data[1].sealNum ? data[1].sealNum : '');
        doc.line(135, _y + 1, 195, _y + 1);
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Status');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].containerStatus ? data[0].containerStatus : '');
        doc.line(40, _y + 1, 100, _y + 1);
    
        doc.setFont("times", "bold");
        doc.text(115, _y, 'Status');
        doc.setFont("times", "normal");
        doc.text(135, _y, data[1].containerStatus ? data[1].containerStatus : '');
        doc.line(135, _y + 1, 195, _y + 1);

        _y += _space * 2;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Customer');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].fromCustomerName ? data[0].fromCustomerName : '');
        doc.line(40, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Grounded CY');
        doc.setFont("times", "normal");
        doc.text(48, _y, data[0].userCyName ? data[0].userCyName : '');
        doc.line(48, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Remarks');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].remarks ? data[0].remarks : '');
        doc.line(40, _y + 1, 195, _y + 1);

        _y += _space * 2;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Van Locator');
        doc.setFont("times", "normal");
        doc.text(47, _y, data[0].vanLocator ? data[0].vanLocator : '');
        doc.line(47, _y + 1, 85, _y + 1);
    
        doc.setFont("times", "bold");
        doc.text(90, _y, 'Van Locator Amount');
        doc.setFont("times", "normal");
        doc.text(135, _y, data[0].vanLocatorAmount && data[0].vanLocatorAmount > 0 ? data[0].vanLocatorAmount.toString() : '');
        doc.line(135, _y + 1, 195, _y + 1);
    
        _y += _space;
    
        if(data[0].containerStatus === 'Damaged'){
            var imageX = 60;
            doc.addImage(containerPic, 'PNG', imageX, _y, 100, 70);
            _y += _space * 15;
    
            doc.setFont("times", "bold");
            doc.text(60, _y, 'Damaged Part/s');
            doc.text(140, _y, 'Type of Damage');
            doc.setFont("times", "normal");
            doc.line(20, _y + 1, 195, _y + 1);
            _y += _space;
            if(data[0].damage && data[0].damage.length > 0){
                data[0].damage.forEach(element => {
                    doc.text(30, _y, element.vanParts);
                    doc.text(120, _y, element.damageType);
                    doc.line(20, _y + 1, 195, _y + 1);
                    _y += _space;
                });
            }
            _y += _space;
        }
    }
    else {
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Trucker:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].truckerName ? data[0].truckerName : '');
        doc.line(55, _y + 1, 195, _y + 1);
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Plate Number:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].plateNum ? data[0].plateNum : '');
        doc.line(55, _y + 1, 195, _y + 1);
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Driver:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].driver ? data[0].driver : '');
        doc.line(55, _y + 1, 195, _y + 1);
    
        _y += _space * 2;
      
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Van No');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].containerVan ? data[0].containerVan : '');
        doc.line(40, _y + 1, 85, _y + 1);
    
        doc.setFont("times", "bold");
        doc.text(90, _y, 'Customer');
        doc.setFont("times", "normal");
        doc.text(110, _y, data[0].fromCustomerName ? data[0].fromCustomerName : '');
        doc.line(110, _y + 1, 195, _y + 1);
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Seal No');
        doc.setFont("times", "normal");
        // doc.text(40, _y, data[0].sealNum ? data[0].sealNum : '');
        doc.line(40, _y + 1, 85, _y + 1);
    
        doc.setFont("times", "bold");
        doc.text(90, _y, 'Grounded CY');
        doc.setFont("times", "normal");
        doc.text(118, _y, data[0].userCyName ? data[0].userCyName : '');
        doc.line(118, _y + 1, 195, _y + 1);
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Status');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].containerStatus ? data[0].containerStatus : '');
        doc.line(40, _y + 1, 85, _y + 1);
    
        doc.setFont("times", "bold");
        doc.text(90, _y, 'Remarks');
        doc.setFont("times", "normal");
        doc.text(110, _y, data[0].remarks ? data[0].remarks : '');
        doc.line(110, _y + 1, 195, _y + 1);
    
        _y += _space * 2;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Van Locator');
        doc.setFont("times", "normal");
        doc.text(47, _y, data[0].vanLocator ? data[0].vanLocator : '');
        doc.line(47, _y + 1, 85, _y + 1);
    
        doc.setFont("times", "bold");
        doc.text(90, _y, 'Van Locator Amount');
        doc.setFont("times", "normal");
        doc.text(135, _y, data[0].vanLocatorAmount && data[0].vanLocatorAmount > 0 ? data[0].vanLocatorAmount.toString() : '');
        doc.line(135, _y + 1, 195, _y + 1);
    
        _y += _space;
    
        if(data[0].containerStatus === 'Damaged'){
            var imageX2 = 60;
            doc.addImage(containerPic, 'PNG', imageX2, _y, 100, 70);
            _y += _space * 15;
    
            doc.setFont("times", "bold");
            doc.text(60, _y, 'Damaged Part/s');
            doc.text(140, _y, 'Type of Damage');
            doc.setFont("times", "normal");
            doc.line(20, _y + 1, 195, _y + 1);
            _y += _space;
            if(data[0].damage && data[0].damage.length > 0){
                data[0].damage.forEach(element => {
                    doc.text(30, _y, element.vanParts);
                    doc.text(120, _y, element.damageType);
                    doc.line(20, _y + 1, 195, _y + 1);
                    _y += _space;
                });
            }
            _y += _space;
        }
    }
    
    return _y;
}

export function VCTSClosingCompose(page, rowL, cts, data) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space;

    // var c0002, c0003, splitFirst;

    // var ct2 = data.terms ? data.terms.find(function (TC) {
    //     return TC.code === "C0002"
    // }) : undefined;

    // c0002 = ct2 !== undefined && ct2.requestValueInDecimal !== 0 && ct2.requestValueInDecimal ? ct2.requestValueInDecimal :
    //     ct2 !== undefined && ct2.stdValueInDecimal ? ct2.stdValueInDecimal : 0;


    // var ct3 = data.terms ? data.terms.find(function (TC) {
    //     return TC.code === "C0003"
    // }) : undefined;

    // c0003 = ct3 !== undefined && ct3.requestValueInDecimal !== 0 && ct3.requestValueInDecimal ? ct3.requestValueInDecimal :
    //     ct3 !== undefined && ct3.stdValueInDecimal ? ct3.stdValueInDecimal : 0;

    // if (c0003 > 0) {
    //     splitFirst = doc.splitTextToSize('NOTE: Please return the container/s within (' + c0002 + ') days, to avoid payment of '
    //         + 'demurrage charges at Php ' + currencyFormat(c0003) + ' per day exceeding the number of allowable free storage.'
    //         , page.maxWidthInPoint);
    // }
    // else {
    //     splitFirst = doc.splitTextToSize('NOTE: Please return the container/s within (' + c0002 + ') days, to avoid payment of '
    //         + 'demurrage charges at Php ' + c0003 + ' per day exceeding the number of allowable free storage.'
    //         , page.maxWidthInPoint);
    // }

    // doc.text(20, _y, splitFirst);
    // _y += (_space * splitFirst.length);

    _y += _space;

    // doc.text(20, _y, 'Issued By:');
    // doc.text(45, _y, data.issuedByName ? data.issuedByName : '');
    // doc.line(45, _y + 1, 95, _y + 1);

    doc.text(100, _y, 'Received By:');
    doc.text(132, _y, data[0].userCreatedName ? data[0].userCreatedName.toUpperCase() : '');
    doc.line(130, _y + 1, 190, _y + 1);
    _y += _space * 1.2;
    doc.text(128, _y, 'Signature over Printed Name');

    _y += _space * 2;
    return _y;
}

// Not Use
export function VCDRBodyOneCompose(page, rowL, cdr, data) {
    var doc = cdr;
    var _y = rowL;
    var _space = page.spacingunit;

    let current_datetime = new Date()
    let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()

    doc.setFont("times", "bold");
    doc.text('CARGO DELIVERY RECEIPT', 110, _y, null, null, 'center');
    doc.setFont("times", "normal");

    _y += _space * 2;
    doc.setFont("times", "bold");
    doc.text(20, _y, 'Booking Reference:');
    doc.setFont("times", "normal");
    doc.text(65, _y, data.bookingRef ? data.bookingRef : '');

    doc.setFont("times", "bold");
    doc.text(130, _y, 'Date:');
    doc.setFont("times", "normal");
    doc.text(150, _y, formatted_date);

    _y += _space;

    doc.setFont("times", "bold");
    doc.text(20, _y, 'CTS No:');
    doc.setFont("times", "normal");
    doc.text(40, _y, data.ctsNum ? data.ctsNum : '');

    doc.setFont("times", "bold");
    doc.text(130, _y, 'Branch:');
    doc.setFont("times", "normal");
    doc.text(150, _y, data.branchName ? data.branchName : '');

    _y += _space * 2;

    return _y;
}

export function VCDRBodyTwoCompose(page, rowL, cdr, data) {
    var doc = cdr;
    var _y = rowL;
    var _space = page.spacingunit;

    doc.setFont("times", "bold");
    doc.text(20, _y, 'Customer:');
    doc.setFont("times", "normal");
    doc.text(60, _y, data.toConsigneeName ? data.toConsigneeName : '');
    doc.line(60, _y + 1, 195, _y + 1);

    _y += _space;

    doc.setFont("times", "bold");
    doc.text(20, _y, 'Customer Rep:');
    doc.setFont("times", "normal");
    // doc.text(60, _y, data.driver ? data.driver : '');
    doc.line(60, _y + 1, 195, _y + 1);

    _y += _space * 2;

    doc.setFont("times", "bold");
    doc.text(20, _y, 'Mode of Delivery:');
    doc.setFont("times", "normal");
    doc.text(60, _y, data.modeOfDelivery ? data.modeOfDelivery : '');
    doc.line(60, _y + 1, 115, _y + 1);

    doc.setFont("times", "bold");
    doc.text(120, _y, 'Vessel:');
    doc.setFont("times", "normal");
    doc.text(145, _y, data.vessel ? data.vessel : '');
    doc.line(145, _y + 1, 195, _y + 1);

    _y += _space;

    doc.setFont("times", "bold");
    doc.text(20, _y, 'Container Status:');
    doc.setFont("times", "normal");
    doc.text(60, _y, data.containerStatus ? data.containerStatus : '');
    doc.line(60, _y + 1, 115, _y + 1);

    doc.setFont("times", "bold");
    doc.text(120, _y, 'Voyage No:');
    doc.setFont("times", "normal");
    doc.text(145, _y, data.voyage ? data.voyage : '');
    doc.line(145, _y + 1, 195, _y + 1);

    _y += _space * 2;

    doc.setFont("times", "bold");
    doc.text(20, _y, 'Trucker:');
    doc.setFont("times", "normal");
    doc.text(60, _y, data.truckerName ? data.truckerName : '');
    doc.line(60, _y + 1, 195, _y + 1);

    _y += _space;

    doc.setFont("times", "bold");
    doc.text(20, _y, 'Plate No:');
    doc.setFont("times", "normal");
    doc.text(60, _y, data.plateNum ? data.plateNum : '');
    doc.line(60, _y + 1, 195, _y + 1);

    _y += _space;

    return _y;
}

export function VCDRBodyThreeCompose(page, rowL, cdr, data) {
    var doc = cdr;
    var _y = rowL;
    var _space = page.spacingunit;
    var margin = 20;
    var pageWidth = doc.internal.pageSize.getWidth();
    var columns = pageWidth / 5;

    _y += _space;
    doc.text(`Qty`, margin, _y);
    doc.text(`Waybill`, (columns * 0.8), _y);
    doc.text(`Container #`, (columns * 1.8), _y);
    doc.text(`Seal Number`, (columns * 2.8), _y);
    doc.text(`Storage`, (columns * 3.8), _y);
    _y += 2;
    doc.line(margin, _y, (pageWidth - margin), _y);
    _y += _space;

    doc.setFont("times", "bold");
    doc.text(`${data.quantityInTeu ? data.quantityInTeu : data.quantity}`, margin, _y);
    doc.text(`${data.wayBillRef}`, (columns * 0.8), _y);
    doc.text(`${data.containerVan}`, (columns * 1.8), _y);
    doc.text(`${data.sealNum}`, (columns * 2.8), _y);
    doc.text(data.storage && data.storage !== 0 ? `Php ${currencyFormat(data.storage)}` : 'Php 0.00', (columns * 3.8), _y);
    doc.setFont("times", "normal");
    _y += 2;
    doc.line(margin, _y, (pageWidth - margin), _y);
    _y += _space * 2;

    doc.text(`Remark:`, margin, _y);
    _y += _space;
    doc.text(`${data.remarks}`, margin, _y);
    doc.line(margin, _y, (pageWidth - margin), _y);
    _y += _space * 2;

    doc.text(20, _y, 'Issued By:');
    doc.text(45, _y, data.issuedByName ? data.issuedByName : '');
    doc.line(45, _y + 1, 95, _y + 1);

    doc.text(100, _y, 'Customer Rep:');
    doc.line(130, _y + 1, 190, _y + 1);
    _y += _space * 1.2;
    doc.text(128, _y, 'Signature over Printed Name');
}